module.exports = __webpack_public_path__ + "img/ghibli-sq4.d48978cb.png";